(function () {

    var formApp = angular.module('formApp');

    formApp.controller('caseNotesHistoryController', ['$scope', '$http', 'DataServices', function ($scope, $http, DataServices) {

        $scope.getHistory = function () {
            $scope.feedbackCaseNotes = DataServices.responseInfo.feedbackCaseNotes;
        };

    }]);
}());